import Breadcrumbs, { Breadcrumb } from '../../library/breadcrumbs/Breadcrumbs';
import ViewOnScreen from '../view-on-screen/ViewOnScreen';
import { FormattedMessage } from 'react-intl';
import { LeftArrow } from '../icons/LeftArrow';
import { PropsWithChildren, ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import { usePageSpacers } from '@app/hooks/usePageSpacers';
import {
  BackButton,
  BackButtonWrapper,
  ContentContainer,
  ContentWrapper,
  HeaderWrapper,
  Title,
  Root,
  TitleContainer,
} from './DashboardHeaderLayoutStyle';

interface DashboardHeaderLayoutProps extends PropsWithChildren {
  title: string;
  breadcrumbs?: Breadcrumb[];
  actionButton?: ReactNode;
  useAutoHeight?: boolean;
  breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

function DashboardHeaderLayout({
  title,
  breadcrumbs,
  actionButton,
  useAutoHeight,
  breakpoint,
  children,
}: DashboardHeaderLayoutProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const effectiveBreakpoint = breakpoint || 'sm';
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values[effectiveBreakpoint]));
  const { navbarSpacerHeight } = usePageSpacers();

  const handleBackClick = () => {
    const pathSegments = location.pathname.split('/').filter((segment) => segment !== '');
    if (pathSegments.length > 1) {
      // Remove the last segment and navigate to parent path
      const parentPath = '/' + pathSegments.slice(0, -1).join('/');
      navigate(parentPath);
    }
  };

  return (
    <Root navbarSpacerHeight={navbarSpacerHeight} useAutoHeight={useAutoHeight} breakpoint={breakpoint}>
      <ContentContainer>
        <HeaderWrapper breakpoint={breakpoint}>
          {isSmallScreen ? (
            <BackButtonWrapper onClick={handleBackClick} breakpoint={breakpoint}>
              <LeftArrow />
              <BackButton>
                <FormattedMessage id='generic.backButtonLabel' />
              </BackButton>
            </BackButtonWrapper>
          ) : (
            breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />
          )}
          <TitleContainer breakpoint={breakpoint}>
            <Title breakpoint={breakpoint}>{title}</Title>
            <ViewOnScreen screen={{ down: effectiveBreakpoint }}>{actionButton}</ViewOnScreen>
          </TitleContainer>
        </HeaderWrapper>

        <ContentWrapper>{children}</ContentWrapper>
      </ContentContainer>
    </Root>
  );
}

export default DashboardHeaderLayout;
